import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { isClientFetchError } from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import {
	fireOperationalAnalytics,
	fireTrackAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import sprintMoveService from '../../rest/sprint-move/index.tsx';
import {
	cancelMoveSprintInteraction,
	setMoveSprintInteractionStartMark,
	stopMoveSprintInteraction,
} from '../../services/performance/interaction-metric-sprint-move';
import { loadAppData } from '../../state/actions/app';
import {
	SPRINT_MOVE_REQUEST,
	sprintMoveFailure,
	sprintMoveSuccess,
	type SprintMoveRequestAction,
} from '../../state/actions/sprints/move';
import { getBaseUrl, getRapidViewId } from '../../state/selectors/app';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types';

export const sprintMoveEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(SPRINT_MOVE_REQUEST).mergeMap((action: SprintMoveRequestAction) => {
		const {
			payload: { sprintId, targetSprintId, analyticsEvent },
			meta: {
				optimistic: { id: optimisticId },
			},
		} = action;

		const state = store.getState();
		const baseUrl = getBaseUrl(state);
		const boardId = getRapidViewId(state);

		setMoveSprintInteractionStartMark();

		return sprintMoveService(baseUrl, boardId, sprintId, targetSprintId)
			.flatMap(() => {
				stopMoveSprintInteraction();
				fireTrackAnalytics(analyticsEvent, 'sprint moved');
				return Observable.of(sprintMoveSuccess(optimisticId));
			})
			.catch((error) => {
				cancelMoveSprintInteraction();
				fireOperationalAnalytics(analyticsEvent, 'sprint moveFailed', {
					isClientFetchError: isClientFetchError(error),
				});
				return Observable.from([sprintMoveFailure(optimisticId), loadAppData()]);
			});
	});
